export default {
  'en': {},
  'sv': {
    'Home': 'Hem',
    'Application': 'Ansökan',
    'Dashboard': 'Översikt',
    'Cases list': 'Ärenden',
    'Customers list': 'Kunder',
    'Invoice customers list': 'Fakturakunder',
    'Invoice details': 'Fakturadetaljer',
    'Certificates list': 'Certifikat',
    'Change language': 'Byt språk:',
    'Login': 'Logga in',
    'Username': 'Användarnamn',
    'Password': 'Lösenord',
    'Case number': 'Ärendenummer',
    'Certification': 'Certifiering',
    'Level': 'Nivå',
    'Date created': 'Ansökningsdatum',
    'Created': 'Skapad',
    'State': 'Status',
    'Responsible': 'Ansvarig',
    'Progress': 'Progress',
    'Updated': 'Uppdaterad',
    'Logout': 'Logga ut',
    'Requested cases': 'Förfrågningar',
    'Assigned cases': 'Tilldelade ärenden',
    'Your ongoing applications': 'Dina pågående ansökningar',
    'Cases waiting on action': 'Väntande ärenden',
    'Case id': 'Diarienr',
    'Auditor': 'Handläggare',
    'Reviewer': 'Handläggare',
    'Manager': 'TG',
    'Requested auditor': 'Begärd handläggare',
    'First name': 'Förnamn',
    'Last name': 'Efternamn',
    'Customer No.': 'Kundnr.',
    'Phone number': 'Telefonnummer',
    'Mobile number': 'Mobilnummer',
    'E-mail': 'E-post',
    'Website': 'Hemsida',
    'Postal address': 'Postadress',
    'Postal code': 'Postnummer',
    'City': 'Ort',
    'Certificate number': 'Certifikatsnummer',
    'Issue date': 'Utfärdat',
    'Validity period (years)': 'Giltighetstid (år)',
    'Expiry date': 'Utgångsdatum',
    'Documents': 'Dokument',
    'Filename': 'Filnamn',
    'Updated At': 'Uppdaterad',
    'Customer profile': 'Kundprofil',
    'swithed': 'bytte',
    'Customer': 'Kund',
    'Customer ID': 'Kundnummer',
    'Personal ID': 'Personnummer',
    'Issued date': 'Utfärdat',
    'Customer detail view': 'Kundinformation',
    'Approve all': 'Godkänn alla',
    'Approve all customer information': 'Godkänn all kundinformation',
    'Approve all documents': 'Godkänn alla dokument',
    'Create certificate...': 'Utfärda certifikat...',
    'Create invoice customer...': 'Skapa fakturakund...',
    'Decision': 'Beslut',
    'Close case': 'Avsluta ärende',
    'Uploaded at': 'Uppladdad',
    'Findings': 'Avvikelser',
    'Describe the non-conformity': 'Beskriv avvikelsen',
    'Save finding': 'Spara avvikelsen',
    'Description:': 'Beskrivning',
    'Comments': 'Kommentarer',
    'Comments:': 'Kommentarer:',
    'Comment:': 'Kommentar:',
    'Comment': 'Kommentar',
    'Rejection comment is required!': 'Avslåkommentar krävs!',
    'Approve': 'Godkänn',
    'Reject': 'Avslå',
    'Reject comment': 'Avslå kommentar',
    'Waiting on auditor': 'Väntar på handläggare',
    'Waiting on customer': 'Väntar på kund',
    'Draft': 'Utkast',
    'Save as draft': 'Spara som utkast',
    'Publish certificate': 'Publicera certifikat',
    'Show certificate': 'Visa certifikat',
    'Published': 'Publicerad',
    'Customer edit': 'Ändra kund',
    'Update profile': 'Uppdatera profil',
    'Cancel': 'Avbryt',
    'Invoicing': 'Fakturering',
    'Messaging': 'Meddelanden',
    'Assign': 'Tilldela',
    'Send request to auditor': 'Skicka förfrågan till handläggare',
    'Case': 'Ärende',
    'Accept case': 'Acceptera ärendet',
    'Reject case': 'Avslå ärendet',
    'Switch profile': 'Byt profil',
    'Review case': 'Granska ärendet',
    'Assign auditor to Case': 'Tilldela handläggare till ett ärendet',
    'Resolve non-conformity:': 'Åtgärda avvikelsen:',
    'Comment (optional):': 'Kommentar (valfritt):',
    'Save': 'Spara',
    'Send in application': 'Skicka in ansökan',
    'Upload': 'Ladda upp',
    'choose a file...': 'välj fil...',
    'Welcome to Kiwa Certification': 'Välkommen till Kiwa Certification',
    'Go to Application Form': 'Gå till ansökan',
    'Go to Login': 'Logga in',
    'Thank you for your application!': 'Tack för din ansökan!',
    'Edit Certificate': 'Redigera certifikat',
    'Certificate': 'Certifikat',
    'Name': 'Namn',
    'Validity period': 'Giltighetsperiod',
    'Customer name': 'Kundnamn',
    'Choose which auditor you would like to assign. A request will be sent to the assigned auditor on which they can choose to accept or reject.': 'Välj handläggare som ska tilldelas ärendet. En förfrågan kommer att skickas till vald handläggare.',
    'Table below lists available auditors.': 'Nedan listas tillgängliga handläggare',
    'This field is required': 'Fältet är obligatoriskt',
    'This field does not match the requested format.': 'Fältet har fel format',
    'Reset Password': 'Återställ lösenord',
    'E-mail sent succesfully. Please check your inbox.': 'E-post skickat framgångsrikt. Kontrollera din inkorg.',
    'Search': 'Sök',
    'The table is empty.': 'Tabellen är tom.',
    'Forgot your password?': 'Glömt ditt lösenord?',
    'Send': 'Skicka',
    'Submit': 'Skicka',
    'Go to dashboard': 'Gå till översikt',
    'Edit certificate': 'Redigera certifikat',
    'Download certificate': 'Ladda ner certifikat',
    'View customer...': 'Visa kund...',
    'Edit customer...': 'Redigera kund...',
    'Signed in as': 'Inloggad som',
    'switched': 'ändrad',
    'Reset profile': 'Återställ profil',
    'Please choose a password': 'Vänligen välj ett lösenord',
    'Invoices will be sent to the customer personally.': 'Fakturor skickas till kunden personligen.',
    'You have no issues for which you are responsible. =)': 'Du har inga ärenden som du är ansvarig för. =)',
    'No issues to handle!': 'Inga ärenden att hantera!',
    'Edit information...': 'Redigera information...',
    'Assign an auditor': 'Tilldela en handläggare',
    'Continue review': 'Fortsätt granska',
    'Continue': 'Fortsätta',
    'Begin review': 'Börja granska',
    'You have already confirmed.': 'Du har redan bekräftat.',
    'Completed reportings': 'Slutförda rapporteringar',
    'Upcoming reportings': 'Kommande rapporteringar',
    'Profile updated': 'Profil uppdaterad',
    'Application sent': 'Ansökan inskickad',
    'Go to start page': 'Gå till startsidan',
    'Invoice reference': 'Fakturareferens',
    'Invoice distribution': 'Fakturadistribution',
    'Issue resolved': 'Uppgift avklarad',
    'There are no completed reports.': 'Det finns inga färdiga rapporter.',
    'Decline case': 'Avvisa ärendet',
    'There are no upcoming reports.': 'Det finns inga kommande rapporter.',
    'Create reporting...': 'Skapa rapportering...',
    'Resolve issue': 'Lös uppgift',
    'Create reporting for period %{period}': 'Skapa rapportering för period %{period}',
    'A report has been created successfully!': 'En rapport har skapats framgångsrikt!',
    'The report has been updated successfully!': 'Rapporten har uppdaterats framgångsrikt!',
    'Decision letter': 'Beslutsbrev',
    'Reported at': 'Rapporterad',
    'Reported by': 'Rapporterad av',
    'Customer information': 'Kundinformation',
    'Registration done': 'Registrering klar',
    'Recommend approval': 'Rekommendera godkännande',
    'Recommend rejection': 'Rekommendera avslag',
    'Issue certificate': 'Ufärda certifikat',
    'Finding description is manadatory!': 'Avvikelsebeskrining krävs!',
    'Case type': 'Ärendetyp',
    'Create renewal case': 'Skapa förnyelseärende',
    'Attachments': 'Dokument',
    'COMMENTS': 'KOMMENTARER',
    'FINDINGS': 'AVVIKELSER',
    'Download decision letter': 'Ladda ner beslutsbrev',
    'You have no cases for which you are responsible. =)': 'Du har inga ärenden som du är ansvarig för. =)',
    'No cases to handle!': 'Inga ärenden att hantera!',
    'Fix Now': 'Komplettera',
    'Issue to solve': 'Uppgifter att komplettera',
    'Title': 'Titel',
    'Reporting': 'Rapportering',
    'Description': 'Beskrivning',
    'Send reporting': 'Skicka in rapportering',
    'Report before': 'Rapportera senast',
    'Here we list any information that you will need to complement and send to Kiwa': 'Här listar vi alla uppgifter som ni måste inkomma med komplettering kring.',
    'Cases stuck on customer': 'Ärenden som fastnat hos kund',
    'Exam date': 'Provdatum',
    'Want ID06 card printed': 'Vill ha ID kort',
    'Exam selection': 'Prov',
    'Cases': 'Ärenden',
    'Revoke certificate': 'Återkalla certifikat...',
    'Approve all information': 'Godkänn all inforamtion',
    'Approve case': 'Godkänn ärende',
    'Work proof': 'Rapportering',
    'We have now sent a confirmation e-mail to the e-mail address you used in the application.': 'Vi har nu skickat ett bekräftelse e-mail til den e-mailadress du angav i ansökan.',
    'Please follow the instructions in the e-mail in order to continue your application.': 'Följ instruktionerna i mailet för att fullfölja din ansökan',
    'No invoice customer chosen for customer. No invoicing available until it is done.': 'Ingen fakturakund angiven på kunden. Fakturering ej möjligt innan detta är åtgärdat.',
    'This customer is connected to an invoice customer.': 'Kunden är kopplad mot en fakturakund',
    'Choose': 'Välj',
    'Create invoice customer': 'Lägg till fakturakund',
    'Create a new invoice customer': 'Lägg till fakturakund',
    'Found %{count} matching invoice customers filtered on orgnumber': 'Hittade %{count} fakturakunder som matchade kundens faktureringsinformation',
    'Invoice customers filtered on customers orgnumber': 'Fakturakunder filtrerade på kundens faktureringsinformation',
    'Are you sure you want to connect customer %{customerId} with invoice customer: %{orgNumber}': 'Vill du koppla kunden mot denna fakturakund med orgnummer %{orgNumber}',
    'Invoice customer': 'Fakturakund',
    'Connected customers': 'Kopplade kunder',
    'Invoice history': 'Faktura historia',
    'Company name': 'Företagsnamn',
    'Org. number': 'Org.nummer',
    'Invoice address': 'Fakturaadress',
    'Mimer customer id': 'Mimer kundid',
    'Article No.': 'Artikelnr.',
    'Price': 'Pris',
    'Qty': 'Antal',
    'Sum': 'Summa',
    'Invoice': 'Faktura',
    'Invoices': 'Fakturor',
    'ADD ARTICLE': 'LÄGG TILL',
    'Confirm': 'Bekräfta',
    'Save as Draft': 'Spara utkast',
    'Phone': 'Telefon',
    'Mobile': 'Mobiltelefon',
    'Postal city': 'Postort',
    'Invoice marking': 'Märkning',
    'KIWA reference': 'KIWA referens',
    'Create new invoice customer': 'Skapa ny fakturakund',
    'Disconnect the invoice customer': 'Koppla bort fakturakund',
    'Create invoice for case %{ caseNumber }': 'Skapa faktura för ärende %{ caseNumber }',
    'Create invoice for customer %{ customerId }': 'Skapa faktura för kund %{ customerId }',
    'Invoice customer will be created in Mimer': 'Fakturakund kommer att skapas i Mimer',
    'Reporting case created': 'Rapporteringsärende skapat',
    'No matching invoice customers found based on supplied invoice information': 'Inga fakturakunder matchade angivet organisationsnummer',
    'No invoice customer chosen!': 'Ingen fakturakund kopplad!',
    'Connect the customer to an existing invoice customer or create a new one below.': 'Koppla en befintlig fakturakund eller skapa en ny nedan.',
    'Only administrators can connect invocie customers.': 'Endast administratörer kan koppla fakturakunder.',
    'This customer is connected to a invoice customer': 'Kunden är kopplad till fakturakund',
    'Invoice customers filtered on orgnumber %{org_no}': 'Fakturakunder filtrerade på orgnummer %{org_no}',
    'This invoice customer is a person': 'Denna fakturakund är en person',
    'Resolve': 'Skicka komplettering',
    'Qualification': 'Behörighet',
    'Go to Application Form for KA': 'Ansök för Kontrollansvarig KA',
    'Go to Application Form for POP': 'Ansök för Pannoperatörer POP',
    'Create invoice...': 'Skapa faktura...',
    'Create invoice': 'Skapa faktura',
    'Edit invoice': 'Redigera faktura',
    'Apply for new service': 'Ny ansökan',
    'Start reporting case': 'Skapa rapporteringsärende',
    'Active': 'Aktivt',
    'Apply now': 'Ansök nu',
    'Apply': 'Ansök',
    'Edit invoice customer...': 'Redigera...',
    'There are no connected customers.': 'Det finns inga anslutna kunder.',
    'Invoice number': 'Fakturanummer',
    'All results: %{ total }': 'Alla resultat: %{ total }',
    'C.no': 'Dnr',
    'Controller': 'Granskare',
    'Claim case': 'Överta ärende',
    'You are going to replace the current controller. Do you want to continue?': 'Du kommer att byta ut den aktuella granskaren. Vill du fortsätta?',
    'Your browser is not supported! You are using %{name}, version %{version}': 'Din webbläsare stöds inte! Du använder %{name}, version %{version}',
    'The code in the link has expired. Please, make a request to reset your password again.': 'Koden i länken har gått ut. Skicka en begäran om att återställa ditt lösenord.',
    'Invoiced': 'Fakturerad',
    'No': 'Nej',
    'Yes': 'Ja',
    'There are no documents for this customer.': 'Det finns inga dokument för den här kunden.',
    'The customer has no cases.': 'Kunden har inga ärenden.',
    'Applied date': 'Ansökningsdatum',
    'View review report': 'Visa granskningsrapport',
    'Case rejected successfully': 'Ärendet avvisades framgångsrikt',
    'This is what happens next': 'Detta kommer att hända härnäst',
    'which you applied with': 'som ni angav i ansökan',
    'We will send you a confirmation letter to the e-mail adress <strong>%{email}</strong>. If you do not recieve this e-mail the you need to contact Kiwa Certification Building and Energy but please check in your spam folder before doing so.': 'Vi kommer nu att skicka dig ett bekräftelsebrev till din e-postadress <strong>%{email}</strong>. Om du inte erhåller detta e-postmeddelande måste du kontakta Kiwa Certification ABs avdelning för Bygg&Energi. Vänligen kontrollera er skräppostmapp innan ni kontaktar kundtjänst.',
    'In order to confirm your application you need to click on the link in the e-mail and choose a password. We will not start the process until the application is confirmed.': 'För att bekräfta er ansökan måste ni klicka på länken i bekräftelsebrevet och välja ett lösenord. Kiwa kommer inte att påbörja certifieringsprocessen förrän ni bekräftat er ansökan.',
    'The system will verify your application and if something is missing you will be requested to resolve any missing information.': 'Certifieringssystemet kommer att verifiera er ansökan och om något saknas kommer ni att ombedas att inkomma med komplettering.',
    'An auditor will be assigned to your case and will go through all sent in documents.': 'Ni kommer sedan att blir tilldelade en handläggare som går igenom all information.',
    'If the auditor can validate all sent in documentation a certification will be issued and sent to your e-mail address.': 'Om handläggaren kan verifiera all inskickad information kommer ett certifikat att utfärdas och skickas via e-post till er e-postadress.',
    'If you have any questions please do not hesitate to contact us on <strong>bygg@kiwa.com</strong> or <strong>0455-305600</strong>.': 'Om ni har några frågor så kontaktar ni Kiwa på e-postadress <strong>se.bygg@kiwa.com</strong> eller telefon <strong>0455-305600</strong>.',
    'Active services': 'Aktiva tjänster och behörigheter',
    'Application date': 'Ansökningsdatum',
    'Service': 'Tjänst',
    'Apply for a new service': 'Ansök för ny tjänst eller behörighet',
    'Add file(s)': 'Lägg till fil(er)',
    'File %{ name } is empty and will not be uploaded.': 'Filen %{ name } är tom och kommer inte att laddas upp.',
    'The invoice was created successfully!': 'Fakturan skapades framgångsrikt!',
    'The invoice was updated successfully!': 'Fakturan uppdaterades framgångsrikt!',
    'The invoice was published successfully!': 'Fakturan publicerades framgångsrikt!',
    'Combine invoice': 'Kombinera faktura',
    'Blank reason': 'Anledning till nollrapport',
    'Do you want to combine this invoice with another invoice?': 'Välj en faktura nedan om du vill kombinera denna faktura med en samlingsfaktura.',
    'Are you sure you want to delete file: %{ file_name }?': 'Vill du radera filen: %{ file_name }?',
    'Automatic invoice could not be created because invoice customer is not set on customer.': 'Automatisk faktura kunde inte skapas eftersom fakturakund inte är inställd på kund.',
    'If you are not a Kiwa customer and would like to apply for a certification click here on the link below. The certification we currently support are:': 'Om du inte är kund hos Kiwa idag och vill ansöka om certifiering, använder du knappen nedan. De certifieringar som vi för närvarande stödjer är:',
    'If you are a customer of Kiwa today and have been notified of renewal or annual reporting, you must log in to the portal.': 'Om du är kund hos Kiwa idag och fått meddelande om förnyelse eller årlig rapportering ska du logga in i portalen.',
    'If you have never been logged in and have not received a password, you must create a password first.': 'Om du aldrig varit inloggad och inte har erhållit ett lösenord så måste du först skapa ett lösenord.',
    'Go to appliation': 'Gå till ansökan',
    'Apply for certification': 'Ansök om certifiering',
    'Renewal of reporting': 'Förnyelse eller rapportering',
    'Create password': 'Skapa lösenord',
    'Log in to the portal': 'Logga in i portalen',
    'Log in with the e-mail address you registered with the application.': 'Logga in med den e-post adress du registrerade vid ansökan.',
    'Create or recover password': 'Skapa eller återställa lösenord',
    'Click here': 'Klicka här',
    'Don\'t know which email address is registered?': 'Vet du inte vilken e-postadress som är registrerad?',
    'to reset your password using your social security number.': 'för att återställa lösenord med hjälp av ditt personnummer.',
    'Enter the email address you registered in the portal. If you have received an email from the portal, use the address to which the portal mail was sent.': 'Ange den e-postadress som du registrerat i portalen. Har du erhållit ett e-mail från portalen använder du adressen som portalens e-mail skickades till.',
    'Send password': 'Skicka lösenord',
    'Welcome to the new application for certification at Kiwa Certification': 'Välkommen till nyansökan för certifering hos Kiwa Certification',
    'The following links lead to a new application for the respective certification. These are only for people who are not yet a customer of Kiwa.': 'Nedanstående länkar leder till en nyansökan för respektive certifiering. Dessa är endast till för personer som ännu ej är kund hos Kiwa.',
    'If you are a former customer and wish to apply for renewal or new certification, you must first login to the portal.': 'Är du redan kund och vill ansökan om förnyelse eller nycertifiering måste du först logga in i portalen.',
    'Go to the login page': 'Gå till loginsidan',
    'Create or recover passwords via social security number': 'Skapa eller återställa lösenord via personnummer',
    'If you do not know which e-mail address you have in the portal, we can send a mail to the e-mail address below given your social security number.': 'Om du inte vet vilken e-postadress du har i portalen, kan vi skicka ett e-mail till den registrerade e-postadressen med hjälp av ditt personnummer.',
    'Create or reset passwords via social security number': 'Skapa eller återställa lösenord via personnummer',
    'Send personal number': 'Skapa personnummer',
    'Welcome to IDUN audit portal for Kiwa Certification': 'Välkommen till Idun ärendeportal för Kiwa Certification',
    'Reset password': 'Återställ lösenord',
    'An email has been sent to the registered address': 'Ett e-mail har skickats till den registrerade adressen',
    'Confirmation': 'Bekräftelse',
    'Are you sure you want to cancel the invoice?': 'Är du säker på att du vill makulera fakturan?',
    'Cancel case...': 'Avsluta ärende...',
    'Cancel case': 'Avsluta ärende',
    'Holder': 'Innehavare',
    'Company': 'Företag',
    'Action': 'Åtgärd',
    'Your ongoing cases': 'Dina pågående ärenden',
    'Social security number': 'Personnummer',
    'Certificate No.': 'Cert.nummer',
    'Employees': 'Medarbetare',
    'Set as invoiced': 'Redan fakturerad',
    'Revert case': 'Åter till handläggning',
    'Cancel invoice': 'Makulera',
    'Suspend certificate': 'Suspendera...',
    'Edit': 'Redigera',
    'Suspended certificates': 'Suspenderade certifikat',
    'Suspended date': 'Suspenderad datum',
    'Closed case due to revoked certificate': 'Stängt ärende p.g.a återkallat certifikat',
    'No suspended certificates to handle!': 'Finns inga suspenderade certifikat',
    'Download': 'Ladda ner',
    'valid certificates with customer information': 'godkända certifikat med kunddata',
    'Save invoice customer': 'Spara fakturakund',
    'Suspension end date': 'Suspenderad t.om',
    'Human resources': 'Rapportansvarig',
    'Human resource': 'Rapportansvarig',
    'Save and mark as complete': 'Spara och markera som klar',
    'Cases customer responded': 'Kund återkopplat',
    'Public certificates': 'Visa certifikat publikt',
    'Send SMS reminder': 'Skicka SMS påminnelse',
    'Send SMS': 'Skicka SMS',
    'Current certificate authority': 'Nuvarande CA',
    'Current certificate number': 'Nuvarande certifikatsnr',
    'Invoice customer...': 'Fakturakund...',
    'Certificate holder': 'Innehavare',
    'Choose certification': 'Välj certifiering',
    'Choose qualification': 'Välj behörighet',
    'Set not invoiceable...': 'Ej fakturerbar...',
    'Set invoiceable...': 'Fakturerbar...',
    'Reported': 'Rapporterad',
    'County': 'Län',
    'Choose county': 'Välj län',
    'Choose service': 'Välj certifiering',
    'Last report state': 'Rapport ärende status',
    'Work load': 'Arbetsfördelning',
    'Deny case': 'Avslå ärende',
    'Exports': 'Exporter',
    'Card orders': 'Kortbeställning',
    'Order ID card(s)': 'Beställ kort',
    'Update order statuses': 'Hämta status',
    'Source': 'Källa',
    'Your certificates': 'Dina certifikat',
    'Order card': 'Beställ ID-kort',
    'Edit information': 'Uppdatera uppgifter',
    'Keep your invoice information up to date': 'Kontrollera era faktureringsuppgifter',
    'Are you still working at %{ company_name }?': 'Är du fortfarande anställd hos %{ company_name }?',
    'Please, update your invoice information as you are missing invoice e-mail address or GLN.': 'Vänligen uppdatera dina faktureringsuppgifter då du saknar faktura e-postadress eller GLN',
    'Please confirm that you want to order a card and also accept that you will be invoiced for this order which is currently priced at 495 SEK excluding VAT.': 'Bekräfta att du vill beställa ID-kort och att du kommer bli fakturerad 495 SEK exklusive moms för denna beställning.',
    'Please, remember to keep your contact information up to date as it ensures that we can get into contact with you for reminders about reporting and renewal cases.': 'Vänligen håll dina kontaktuppgifter uppdaterade så att vi kan informera dig om kommande rapporteringar och förnyelser.',
    'Current customers regarding certification': 'Certifieringsärenden för nuvarande kunder',
    'If you are a customer of Kiwa Certification AB today and have received a notification about renewal or annual reporting, you should log in to your Idun case page and make the additions that are on your overview.': 'Om du är kund hos Kiwa Certification AB idag och fått meddelande om förnyelse eller årlig rapportering skall du logga in på din ärendesida Idun och utföra de kompletteringar som finns på din översikt.',
    'You can find forms at https://kiwa.se under the respective certification.': 'Blanketter söker du på kiwa.se under respektive certifiering.',
    'If you have been certified or you have a valid certificate with Kiwa Certification AB and want to apply for a different certification or authorization level, you must log in to your case page and click on New application on your overview.': 'Har du varit certifierad eller du har ett giltigt certifikat hos Kiwa Certification AB och vill ansöka om en annan certifiering eller behörighetsnivå så måste du logga in på din ärendesida och klicka på Ny ansökan på din översikt.',
    'If you have changed your email address, you must contact Kiwa Certification AB, 0455-305600 ext. or se.bygg@kiwa.com.': 'Har du bytt e-postadress så måste du kontakta Kiwa Certification AB, 0455-305600 vxl. eller se.bygg@kiwa.com.',
    'In your email you will find a confirmation email for the exam you booked.': 'Då du även bokade ett prov i samband med ansökan kommer du att erhålla ett bekräftelsemail från Provportalen.kiwa.se också.',
    'You need to select a qualification before you can select an exam!': 'Du måste välja behörighet innan du kan välja provtillfälle.',
    'Loading available exams. Please wait...': 'Söker efter tillfällen. Vänligen vänta...',
    'There are no available exams. If you think this is a mistake, please contact us at se.bygg@kiwa.com or 0455-305600.': 'Det finns inga provtillfällen för den certifiering du söker. För ytterligare information kontakta <strong>se.bygg@kiwa.com</strong> eller <strong>0455-305600</strong>.'
  }
}
